function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled from 'styled-components';
import { withSpacing } from '../lib/hoc/withSpacing';
const StyledEmbedWrapper = styled.div.withConfig({
  displayName: "Embed__StyledEmbedWrapper",
  componentId: "vjjy70-0"
})(["position:relative;display:block;overflow:hidden;padding:0;width:100%;height:0;padding-bottom:", ";"], x => `calc((${x.$ratioH / x.$ratioW}) * 100%)`);
const StyledIframe = styled.iframe.withConfig({
  displayName: "Embed__StyledIframe",
  componentId: "vjjy70-1"
})(["position:absolute;top:0;bottom:0;left:0;width:calc(100% + 1px);height:calc(100% + 1px);border:0;"]);

const EmbedFunc = (_ref) => {
  let {
    allowFullScreen = true,
    ratio = '16x9',
    src,
    title
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["allowFullScreen", "ratio", "src", "title"]);

  const ratioW = Number(ratio.split('x')[0]);
  const ratioH = Number(ratio.split('x')[1]);
  return /*#__PURE__*/React.createElement(StyledEmbedWrapper, {
    $ratioH: ratioH,
    $ratioW: ratioW
  }, /*#__PURE__*/React.createElement(StyledIframe, _extends({
    title: title,
    frameBorder: "0",
    src: src,
    allowFullScreen: allowFullScreen
  }, rest)));
};

export const Embed = withSpacing(EmbedFunc);